import { DEFAULT_DISCLAIMER } from './badges';

// Shared document policy, including existing saved sheets with older metadata.
export const DOCUMENT_DISCLAIMER = DEFAULT_DISCLAIMER;
export const DOCUMENT_BRAND = 'LPA';
export const US_FOOTER = Object.freeze({
  name: DOCUMENT_BRAND,
  wordmark: DOCUMENT_BRAND,
  site: 'lpalighting.com/us/',
  url: 'https://lpalighting.com/us/',
  email: 'USA@lpaenergygroup.com',
});